(() => {
  const host = document.querySelector('[data-floyd-newsletter]');
  if (!host || host.dataset.initialized) return;
  host.dataset.initialized = 'true';
  const preview = host.dataset.preview === 'true' ||
    (host.dataset.themeRole === 'unpublished' && new URLSearchParams(location.search).has('newsletter_preview'));
  if (preview) host.dataset.preview = 'true';
  const returned = host.querySelector('template').content.querySelector('[data-newsletter-result]').dataset.newsletterResult !== 'idle';
  try {
    if (!preview && !returned && (host.dataset.subscribed === 'true' ||
        localStorage.getItem('floyd:newsletter:closed') ||
        localStorage.getItem('1129111-dismissed-after-submit') ||
        localStorage.getItem('1129111-dismissed-in-session'))) return;
  } catch (_) { /* A blocked storage area must not break the page. */ }

  const abort = new AbortController();
  const options = { signal: abort.signal, passive: true };
  let interacted = preview || returned;
  let loaded = document.readyState === 'complete';
  let started = false;
  const consentResolved = () => {
    if (preview || returned) return true;
    try { return window.UC_UI?.isConsentRequired() === false; }
    catch (_) { return false; }
  };
  const start = () => {
    if (started || !loaded || !interacted || document.hidden || !consentResolved()) return;
    started = true;
    abort.abort();
    // No provider bundle, CSS or CAPTCHA is requested by the startup gate.
    import(new URL(host.dataset.module, location.href).href).then(module => module.mount(host)).catch(error => {
      host.dataset.state = 'unavailable';
      if (preview) host.dataset.error = error.message;
    });
  };
  const interact = () => { interacted = true; start(); };
  window.addEventListener('load', () => { loaded = true; start(); }, options);
  for (const type of ['pointerdown', 'keydown', 'scroll']) {
    window.addEventListener(type, interact, options);
  }
  for (const type of ['UC_UI_INITIALIZED', 'UC_UI_VIEW_CHANGED', 'ucEvents']) {
    window.addEventListener(type, start, options);
  }
  document.addEventListener('visibilitychange', start, options);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.contains(host)) abort.abort();
  }, { signal: abort.signal });
  start();
})();
